import { x } from '@xstyled/styled-components';
import { CHAPTER, CHAPTER_SELECTION } from '..';
import {
  Item,
  ItemDefinition,
  ItemValidationError,
  registry,
  RenderProps
} from '../Item';
import React from 'react';

export type ChapterSelectionDefinition = ItemDefinition<
  typeof CHAPTER_SELECTION,
  void
>;

export class ChapterSelection extends Item<typeof CHAPTER_SELECTION, void> {
  validate() {
    if (!this.definition.items.length) {
      throw new ItemValidationError(
        `An item of type [${CHAPTER_SELECTION}] must have children`
      );
    }

    if (this.definition.items.some(i => i.type !== CHAPTER)) {
      throw new ItemValidationError(
        `An item of type [${CHAPTER_SELECTION}] can only have children of type [${CHAPTER}]`
      );
    }
  }

  protected render({ children }: RenderProps<void>) {
    return (
      <x.div display="flex" gap="md" flexDirection={{ _: 'column', md: 'row' }}>
        {children}
      </x.div>
    );
  }
}

registry[CHAPTER_SELECTION] = ChapterSelection;
